var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgWindow",style:({ background: _vm.imgWindow.bgColor })},[_c('div',{class:['layout','layout'+_vm.imgWindow.imgCount+_vm.imgWindow.layout]},_vm._l((_vm.imgWindow.list),function(item,index){return _c('img',{key:index,class:['imgBox','index'+index],attrs:{"src":item.imgUrl,"alt":""}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }